<div class="container common-add" *ngIf="!newAdd ">
  
  <div class="row main-div">
      <div class="col-11">
        <div class="row">
          <div>
            <div class="vs-text-field">
              <label class="add-search"
                >{{ "addressData.selectPlaceholder" | cxTranslate }} {{ componentAddress }}{{ "addressData.addressBook" | cxTranslate }}</label>
              <input
                type="text"
                class="search-btn"
                [placeholder]="placeholder"
                [(ngModel)]="term"
                (keydown.enter)="addressSearch()"
                #search name="search"
              /><i *ngIf="!showAddProductLoader" (click)="addressSearch()" class="material-icons search-icon"
                  >search</i
                >
                <div
                *ngIf="showAddProductLoader"
                class="availability-spinner float-right cx-spinner"
              >
                <cx-spinner></cx-spinner>
              </div>
            </div>
          </div>
          <!-- <div class="col-6 btn-col">
            <button class="vs-primary-btn sample-btn new-add" *ngIf="componentAddress === 'Ship To' || componentAddress === 'End Customer'">
              <span (click)="addAddress()">+ Add New Address</span>
            </button>
          </div> -->
          <div class="add-count">{{ "addressData.thereAre" | cxTranslate }} <strong>{{userAddressList.length}}</strong>{{ "addressData.addressesFound" | cxTranslate }} </div>
        </div>
        
      </div>
      <div class="col-1" (click)="closeForm()"><i class="material-icons close-icon" >close</i></div>
    <!-- </div> -->    
    <div *ngIf='userAddressList$ | async else loading' class="button-addresses">
      <div
        class="vs-radio-button mb-2 tableaddress-text"
        *ngFor="let userAddress of userAddressList; let i = index"
      >
        <!-- <div *ngIf="i < 5"> -->
          <input
            id="{{ componentAddress + i }}"
            type="radio"
            (click)="onStatusChange(userAddress)"
            [checked]="userAddress.id == this.radioSelected"
            [disabled]="userAddress.isSoldToMatch"
          />
          <label for="{{ componentAddress + i }}" class="tb-content" [ngClass]="{'disabled-address': userAddress.isSoldToMatch}">
            {{ userAddress.companyName }}, {{ userAddress.firstName }} {{ userAddress.lastName
            }} {{ userAddress.formattedAddress }} {{ userAddress?.country?.name }}</label
          >
          <!-- </div> -->
      </div>
      
    </div>

  </div>
  <div class="newAddLink" *ngIf="componentAddress === 'Ship To' || componentAddress === 'End Customer'">{{ "addressData.cannotFind" | cxTranslate }} <a (click)="addAddress()">{{ "addressData.clickHere" | cxTranslate }}</a>{{ "addressData.newAddress" | cxTranslate }}</div>
</div>
<div *ngIf="newAdd" class="new-address-from">
  <div class="row" >
    <div class="col-11">
      <div class="vs-text-field">
        <label class="add-address-form"
          >{{ "addressData.addNew" | cxTranslate }}{{ componentAddress }}{{ "addressData.addToBook" | cxTranslate }}</label>
      </div>
    </div>
    <div class="col-1" (click)="closeForm()"><i class="material-icons close-icon" >close</i></div>
  </div>
  <form ngNativeValidate [formGroup]="addressForm">
    <div class="add-form">
      
        <!-- <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-6">
            <div class="vs-text-field">
              <label><span class="star">*</span> First Name</label>
              <input
                placeholder="First Name"
                class="wdt334"
                type="text"
                formControlName="firstName"
              />
              <label class="error" *ngIf="isSubmitted && firstName.invalid && addressForm.invalid">Please enter First Name</label>
            </div>
          </div>

          <div class="col-md-6 col-lg-6 col-sm-6">
            <div class="vs-text-field">
              <label><span class="star">*</span> Last Name</label>
              <input
              placeholder="Last Name"
                class="wdt334"
                type="text"
                formControlName="lastName"
                name="lastName"
              />
              <label class="error" *ngIf="isSubmitted && lastName.invalid && addressForm.invalid">Please enter Last Name</label>
            </div>
          </div>
        </div> -->

        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-6">
            <div class="vs-text-field mt-3">
              <label><span class="star">*</span>{{ "addressData.companyName" | cxTranslate }}</label>
              <input
                placeholder='{{ "addressData.companyName" | cxTranslate }}'
                class="wdt334"
                type="text"
                formControlName="companyName"
                maxlength="35"
              />
              <label class="error" *ngIf="isSubmitted && companyName.invalid && addressForm.invalid">{{ "addressData.companyName2" | cxTranslate }}</label>
            </div>
          </div>

        </div>


        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-6">   
              <div class="vs-text-field mt-3">
              <label><span class="star">*</span>{{ "addressData.endUserAddressL1" | cxTranslate }}</label>
              <input
                placeholder="Select"
                class="wdt334"
                type="text"
                formControlName="line1"
                name="line1"
                maxlength="35"
              />
              <label class="error" *ngIf="isSubmitted && line1.invalid && addressForm.invalid">{{ "addressData.endUserAddressL11" | cxTranslate }}</label>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-sm-6">
            <div class="vs-text-field mt-3">
              <label><span class="star"></span>{{ "addressData.endUserAddressL2" | cxTranslate }}</label>
              <input
                placeholder='{{ "addressData.selectPlaceholder" | cxTranslate }}'
                class="wdt334"
                type="text"
                formControlName="line2"
                name="line2"
                maxlength="35"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-6">   
            <div class="mt-3">
              <label><span class="star">*</span>{{ "addressData.endUserCountry" | cxTranslate }}</label>
              <ng-select
                [searchable]="true"
                [clearable]="false"
                placeholder='{{ "addressData.selectPlaceholder" | cxTranslate }}'
                appendTo='body'
                class="address-dropdown-width"
                formControlName="country"
                (change)="countryRegions()"
              >
                <ng-option value="">{{ "addressData.selectPlaceholder" | cxTranslate }}</ng-option>
                <ng-option
                  *ngFor="let country of countryNames; let i = index"
                  [value]="country.isocode"
                >
                  {{ country.name }}</ng-option
                >
              </ng-select>
              
              <label class="error" *ngIf="isSubmitted && country.invalid && addressForm.invalid">{{ "addressData.endUserCountry2" | cxTranslate }}</label>
            </div>
          </div>

          <div class="col-md-6 col-lg-6 col-sm-6">   
            <div class="mt-3">
              <label><span class="star" *ngIf="countryRegionNames?.length>0">*</span> {{ "addressData.endUserState" | cxTranslate }}</label>
              <ng-select  
                [searchable]="true"
                [clearable]="false"
                placeholder='{{ "addressData.selectPlaceholder" | cxTranslate }}'
                class="address-dropdown-width"
                appendTo='body'
                id="selectRegionArea"
                formControlName="state"
              >
                <ng-option value="">{{ "addressData.selectPlaceholder" | cxTranslate }}</ng-option>
                <ng-option
                  *ngFor="let region of countryRegionNames; let i = index"
                  [value]="region.isocode"
                  value="region.isocode"
                  >{{ region.name }}</ng-option
                >
              </ng-select>
              
              <label class="error" *ngIf="isSubmitted && state.invalid && addressForm.invalid">{{ "addressData.endUserState2" | cxTranslate }}</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-6">
            <div class="vs-text-field mt-3">
              <label><span class="star">*</span> {{ "addressData.endUserCity" | cxTranslate }}</label>
              <input
                placeholder='{{ "addressData.selectPlaceholder" | cxTranslate }}'
                class="wdt334"
                type="text"
                formControlName="city"
                name="city"
                maxlength="35"
              />
              <label class="error" *ngIf="isSubmitted && city.invalid && addressForm.invalid">{{ "addressData.endUserCity2" | cxTranslate }}</label>
            </div>
          </div>

          <div class="col-md-6 col-lg-6 col-sm-6">
            <div class="vs-text-field mt-3">
              <label><span class="star" *ngIf="country.value != 'CN'">* </span> {{ "addressData.endUserZip" | cxTranslate }}</label>
              <input
                placeholder='{{ "addressData.selectPlaceholder" | cxTranslate }}'
                class="wdt334"
                type="text"
                [ngClass]="
            (postalCode.invalid &&
              (postalCode.dirty || postalCode.touched) &&
              !postalCode.valid) ||
            (isSubmitted && !postalCode.valid) ? 'error' : ''"
                formControlName="postalCode"
                name="postalCode"
                maxlength="10"
              />
              <label class="error" *ngIf="isSubmitted && postalCode.invalid && addressForm.invalid || 
              (postalCode.invalid &&
                (postalCode.dirty || postalCode.touched) &&
                !postalCode.valid)">{{ "addressData.endUserZip2" | cxTranslate }}</label>
            </div>
          </div>
        </div>
        <div *ngIf="componentAddress === 'Ship To' || componentAddress === 'Sold to'" class="row custom-margin-address">
          <div class="vs-checkbox">
            <input id="agree-custom" type="checkbox" (change)=getSaveAddress($event) [(ngModel)]="userAddressSave"
             [value]="userAddressSave" name="saveAddress" formControlName="saveAddress">
            <label for="agree-custom">
              {{ "addressData.saveAddress" | cxTranslate }}
            </label>
          </div>
        </div>
        <div *ngIf="componentAddress === 'End Customer'" class="row custom-margin-address">
          <div class="vs-checkbox">
            <input id="agree-custom2" type="checkbox" (change)=getEndAddress($event) [(ngModel)]="endUserAddress"
             [value]="endUserAddress" name="endAddress" formControlName="endAddress">
            <label for="agree-custom2">
              {{ "addressData.endAddress" | cxTranslate }}
            </label>
          </div>
        </div>

      <div class="row custom-margin-top-address">
        <button class="vs-text-btn cancel-button"(click)="cancel()">
          <span class="cancel-add mr-3" ><a>{{ "addressData.Cancel" | cxTranslate }}</a></span
        >
        </button>
        
        <div class="ter-btn-holder">
          <button class="vs-tertiary-btn" (click)="onSubmit()" type="submit">
            {{ "addressData.addAddress" | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #loading >
  <div class="address-search-spinner cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>